<template>
  <div v-if="venueSettings">
    <div class="flex justify-between p-3">
      <p>
        Venue settings determines how specific features of the POS system is set
        up
      </p>
      <div class="flex justify-end">
        <vs-button
          icon="save"
          @click="onClickSaveSettings"
          type="relief"
          color="primary"
          class="mr-3"
          >Save</vs-button
        >
      </div>
    </div>
    <h5 class="ml-2">Table settings</h5>
    <vs-row class="ml-4 mt-4">
      <SidebarItem label="Venue table bookings has minimum spend">
        <vs-select
          v-model="venueSettings.hasEnabledMinSpendForBookings"
          class="w-full"
        >
          <vs-select-item
            :key="item.value"
            :value="item.value"
            :text="item.name"
            v-for="item in [
              { value: false, name: 'No' },
              { value: true, name: 'Yes' },
            ]"
          />
        </vs-select>
      </SidebarItem>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "@/components/Custom/SidebarItem.vue";

export default {
  components: {
    SidebarItem,
  },
  data() {
    return {};
  },
  methods: {
    async onClickSaveSettings() {
      this.$vs.loading();
      await this.$store.dispatch("pos/venues/updateSettings", {
        venueId: this.venue.id,
        settings: this.venueSettings,
      });
      this.$vs.loading.close();
    },
  },
  computed: {
    ...mapGetters({
      venue: "pos/venues/venue",
      venueSettings: "pos/venues/venueSettings",
    }),
  },
  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("pos/venues/getSettings", this.venue.id);
    this.$vs.loading.close();
  },
};
</script>


<style lang="scss" scoped>
</style>